export default {
    title: "Votre responsable approbateur est {email}"
}